import { gameRoundInfo } from '../store';
import { applyTopSlotToBonusGame, waitForBonusTransitionToFinish, waitEnd, waitForPlayClick } from './machine/helpers';
import { backend } from '../backend';
import { GameState, gameStates } from './machine/state-types';
import { EventEmitterInstance } from '../utils/event-emitter';
import { playAudio } from '../utils/audio';

export const state: GameState = {
    name: gameStates.ballSpin,
    onEnter: async setState => {
        await waitForBonusTransitionToFinish();
        await applyTopSlotToBonusGame();
        await waitForPlayClick();

        const result = await backend.playBonus('BALL_SPIN');
        gameRoundInfo.set(result);

        EventEmitterInstance.emit('response-bonus-ball-spin', result);

        await waitEnd();

        if (result.final) setState(gameStates.bigWin);
        else setState(gameStates.ballSpin);
    },
    onExit: () => {}
};
